import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
export const app = initializeApp(firebaseConfig);

// Only initialize analytics in browser environment
export const analytics =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
    ? { logEvent: () => {} } // Mock in test environment
    : getAnalytics(app); // Real analytics in production/development

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
const localhost = process.env.REACT_APP_HOST || 'localhost';
if (
  process.env.REACT_APP_ENV === 'test' &&
  window.location.hostname === localhost
) {
  console.log('connecting to emulators ci');
  connectAuthEmulator(auth, `http://${localhost}:9045`);
  connectFirestoreEmulator(db, localhost, 9046);
  connectStorageEmulator(storage, localhost, 9047);
  connectFunctionsEmulator(functions, localhost, 9048);
} else if (
  window.location.hostname === localhost &&
  process.env.NODE_ENV === 'development'
) {
  console.log('connecting to emulators locally');
  connectAuthEmulator(auth, `http://${localhost}:9099`);
  connectFirestoreEmulator(db, localhost, 8080);
  connectStorageEmulator(storage, localhost, 9199);
  connectFunctionsEmulator(functions, localhost, 5001);
}

export const USERS_PATH = 'users';
export const PLANS_PATH = 'plans';
export const DESIGNS_PATH = 'designs';
export const SUBSCRIPTIONS_PATH = 'subscriptions';
export const PROFILES_PATH = 'profiles';
export const FOLDERS_PATH = 'folders';
export const ARCHIVED_DESIGNS_PATH = 'archivedDesigns';
export const TERMS_PATH = 'terms';
export const USER_PREFERENCES_PATH = 'userPreferences';

// empty commit
